import { useMutation } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks } from '../../types/my-types';
import { IExtractionBatchCreateParams } from '../../api/types';

export const useCreateExtractionBatch = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: IExtractionBatchCreateParams) => await (await glynt).extractionBatch.create(data),
    ...callbacks
  });
};
